import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hasAssociatedSubscription", "isPaymentCollectedAutomatically", "invoiceHasPayments", "currencyValidatorError", "maybeCurrencyValidationError", "onClickButton", "invoiceId", "hasAllGates"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { actions } from '../../constants/actions';
import { usePreloadedInitialInvoiceData } from '../../hooks/usePreloadedInitialInvoiceData';
import { InvoiceOperation } from '../../types/InvoiceOperation';
import { INVOICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const EditInvoiceButton = _ref => {
  let {
      hasAssociatedSubscription,
      isPaymentCollectedAutomatically,
      invoiceHasPayments,
      currencyValidatorError,
      maybeCurrencyValidationError,
      onClickButton,
      invoiceId,
      hasAllGates
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const tooltipMessage = invoiceHasPayments ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.invoiceActionsDropdown.tooltips.editDisabled.hasAssociatedPayment"
  }) : isPaymentCollectedAutomatically || hasAssociatedSubscription ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.invoiceActionsDropdown.tooltips.editDisabled.hasAssociatedSubscription"
  }) : currencyValidatorError ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.invoiceActionsDropdown.tooltips.editDisabled.unknownError"
  }) : maybeCurrencyValidationError;
  const {
    preloadedInitialInvoiceData
  } = usePreloadedInitialInvoiceData({
    objectId: invoiceId,
    objectTypeId: INVOICE_TYPE_ID,
    operation: InvoiceOperation.EDIT,
    hasAllGates,
    skip: buttonProps.disabled
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "edit-btn-tooltip",
    disabled: !buttonProps.disabled,
    title: tooltipMessage,
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      "data-test-id": "edit-btn",
      use: "tertiary-light",
      responsive: false,
      size: "extra-small",
      onClick: () => onClickButton(actions.EDIT, {
        preloadedInitialInvoiceData
      })
    }, buttonProps, {
      disabled: buttonProps.disabled,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.buttons.edit"
      })
    }), "edit-btn")
  }, "edit-btn-tooltip");
};
export default EditInvoiceButton;